let BaseURL = process.env.REACT_APP_API_BASE_URL

export function getV1URL(path) {
    let prefix = "api/v1"
    return `${BaseURL}/${prefix}/${path}`
}

export function resolveBaseURL(path) {
    return `${BaseURL}/${removeStartSlash(path)}`
}

function removeStartSlash(path) {
    return path.replace(/^\/+/, "");
}